import TrashIcon from '@heroicons/react/outline/TrashIcon'

import { Button } from '@tribeplatform/react-ui-kit/Button'
import { FormControl } from '@tribeplatform/react-ui-kit/FormControl'
import { List } from '@tribeplatform/react-ui-kit/Layout'
import { useSlateComponent, useSlateKit } from '@tribeplatform/slate-kit/hooks'

import { NavbarNavigationAction, NavbarNavigationItem } from '../constants'
import { getOldNavigationItems } from '../utils'

export type NavbarNavigationItemSettingsProps = {
  itemIndex: number
}

export const NavbarNavigationItemSettings = ({
  itemIndex,
}: NavbarNavigationItemSettingsProps) => {
  const { context, popActiveBlock } = useSlateKit()
  const { component, upsertProp } = useSlateComponent()

  const { navigationItems: newNavigationItems } = component?.props || {}
  const navigationItems: NavbarNavigationItem[] =
    newNavigationItems || getOldNavigationItems(context.network)
  const item: NavbarNavigationItem = navigationItems[itemIndex]

  if (!item) return null

  const { label } = item
  // let readyToSave: boolean = item.label && item.action && true
  // switch (item.action) {
  //   case NavbarNavigationAction.OPEN_LINK:
  //     readyToSave = readyToSave && item.link && true
  //     break
  // }

  const updateItem = update => {
    const newItems = navigationItems.map((item, idx) =>
      idx === itemIndex
        ? { ...item, ...update, action: NavbarNavigationAction.OPEN_LINK }
        : item,
    )
    upsertProp('navigationItems', newItems)
  }
  const deleteItem = () => {
    popActiveBlock()
    upsertProp('navigationItems', [
      ...navigationItems.slice(0, itemIndex),
      ...navigationItems.slice(itemIndex + 1),
    ])
  }

  return (
    <List spacing="sm">
      <List.Item>
        <FormControl.Input
          name="label"
          value={label}
          onChange={e => {
            updateItem({ label: e.target.value })
          }}
          label="Label"
        />
      </List.Item>
      <List.Item>
        <FormControl.Input
          name="link"
          value={item.link}
          onChange={e => {
            updateItem({ link: e.target.value })
          }}
          label="Link"
        />
      </List.Item>
      <List.Item>
        <FormControl.Toggle
          name="newWindow"
          label="Open in a new window"
          checked={item.openInNewWindow}
          onChange={openInNewWindow => {
            updateItem({ openInNewWindow })
          }}
        />
      </List.Item>
      <List.Item className="mt-4">
        <Button
          variant="outline"
          leadingIcon={<TrashIcon />}
          onClick={deleteItem}
          fullWidth
        >
          Delete
        </Button>
      </List.Item>
    </List>
  )
}
